import { css } from '@emotion/core';
import { black, gray5, hexToRgbaString, lightCyan } from 'styles/global_defaults/colors';
import { doubleSpacing, halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

// SuggestActivities styles start
export const lhsStyles = css`
  &.generate-box {
    border: double 2px transparent;
    border-radius: ${halfSpacing}px;
    margin: -2px;
    border-image-slice: 2;
    background-color: ${lightCyan};
    background-image: linear-gradient(${lightCyan}, ${lightCyan}),
      linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    gap: ${standardSpacing}px;
  }
`;

export const lhsCommonStyles = css`
  .text-lg-bold {
    font-size: 16px;
    line-height: 25px;
    font-weight: 700;
  }
`;

export const suggestedActivitiesStyles = css`
  gap: ${doubleSpacing}px;

  .list-item {
    border-top: 1px solid ${gray5};
  }

  .list-item:last-child {
    border-bottom: 1px solid ${gray5};
  }
`;
// Suggest Activities styles end
